// extracted by mini-css-extract-plugin
module.exports = {"colorStyle":"style_colorStyle__1lkLI"};